import { render, staticRenderFns } from "./FieldGroup.vue?vue&type=template&id=2071cc3c&scoped=true"
import script from "./FieldGroup.vue?vue&type=script&lang=js"
export * from "./FieldGroup.vue?vue&type=script&lang=js"
import style0 from "./FieldGroup.vue?vue&type=style&index=0&id=2071cc3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2071cc3c",
  null
  
)

export default component.exports